import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-400 py-12 px-4 text-center" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <h3 className="text-2xl font-black text-white mb-4" data-id="element-134">
          🧬 BIOLOGÍA EN ACCIÓN
        </h3>
        <p className="mb-2" data-id="element-135">
          El sistema de planificación de Biología N°1 para docentes de
          secundaria en Argentina.
        </p>
        <p className="mb-8 italic" data-id="element-136">Enseñá mejor. Viví más.</p>

        <div className="border-t border-gray-800 pt-8 text-sm" data-id="element-137">
          <p className="mb-4" data-id="element-138">
            © 2025 BIOLOGÍA EN ACCIÓN™ — Guía Digital 360
          </p>
          <div className="flex justify-center gap-4" data-id="element-139">
            <a href="#" className="hover:text-white transition-colors" data-id="element-140">
              Privacidad
            </a>
            <span data-id="element-141">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-142">
              Términos y Condiciones
            </a>
          </div>
        </div>
      </div>
    </footer>;
}